import api from './apiClient';

const apiBillingEntitlement = async () => {
    try {
        const response = await api.get('/api/captions/billing/entitlement');
        return response.data;
    } catch (error) {
        if (error.response?.status === 401 || error.response?.status === 403) {
            return null;
        }
        throw error;
    }
};

export default apiBillingEntitlement;
